module.exports = __webpack_public_path__ + "img/svg/screenshot.8952ddb99f09223277031c90e548c0c9.svg";